import React from 'react';
import {
  TableColumn,
  TableCells,
  TableFilterCells,
  ApiFilterOperation,
} from '@eas/common-web';
import { SoapMessageLog } from '../../models';
import {
  useWebServices,
  useWebOperations,
} from '../web-service/web-services-api';
import Typography from '@material-ui/core/Typography';

export function useColumns(): TableColumn<SoapMessageLog>[] {
  return [
    {
      datakey: 'service',
      sortkey: 'service',
      filterkey: 'service',
      name: 'Služba',
      width: 200,
      CellComponent: function Cell({ value, rowValue }) {
        return (
          <Typography variant="body1">
            {value ?? rowValue?.service ?? '-'}
          </Typography>
        );
      },
      valueMapper: TableCells.useSelectCellFactory(useWebServices),
      FilterComponent: TableFilterCells.FilterTextCell,
      filterOperation: ApiFilterOperation.CONTAINS,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'localPart',
      sortkey: 'localPart',
      filterkey: 'localPart',
      name: 'Operace',
      width: 200,
      FilterComponent: TableFilterCells.FilterTextCell,
      CellComponent: function Cell({ value, rowValue }) {
        return (
          <Typography variant="body1">
            {value ?? rowValue?.localPart ?? '-'}
          </Typography>
        );
      },
      valueMapper: TableCells.useSelectCellFactory(useWebOperations),
      filterOperation: ApiFilterOperation.CONTAINS,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'duration',
      name: 'Trvání',
      width: 200,
      CellComponent: TableCells.NumberCell,
      sortable: true,
      filterable: true,
    },

    {
      datakey: 'updatedBy',
      displaykey: 'updatedBy.name',
      filterkey: 'updatedBy.name',
      sortkey: 'updatedBy.name',
      name: 'Autor úpravy',
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
  ];
}
